import { PostForecastForReceiptRequest } from '@/coreInfrastructureModule/axios/generated/forecastForReceiptManage/api';
import { ForecastForReceiptFormState } from '../domains/entities/ForecastForReceiptMenu';

/**
 * 受領用内示新規作成のアダプタ
 */
export class PostForecastForReceiptAdapter {
  /**
   * リクエストをAPI用に変換する
   * @param newForecastForReceiptInfo - 新たに作成する受領用内示の情報
   */
  public static adaptForRequest(newForecastForReceiptInfo: ForecastForReceiptFormState): PostForecastForReceiptRequest {
    return {
      // STOPSHIP
      postForecastForReceiptInfo: {
        forecastForReceiptName: newForecastForReceiptInfo.forecastForReceiptName,
        forecastForReceiptResponsibleUserIdList: newForecastForReceiptInfo.forecastForReceiptResponsibleUserIdList,
        outputRange: newForecastForReceiptInfo.outputRange ?? 0, // 渡ってきてないならAPI側でエラー出せるように0を入れておく
      },
    };
  }
}
